import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_mst_entity_e_consent_request_RowClass } from '../../../dbschema/bl_fi_mst_entity_e_consent_request.model';

export class EConsentRequestContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_e_consent_request: bl_fi_mst_entity_e_consent_request_RowClass = new bl_fi_mst_entity_e_consent_request_RowClass();
}
